export default __webpack_public_path__ + "static/oncologica-98e6c13726aa1819f47d54f3386a1b3d.jpg";